"use client"

import { useEffect } from "react"
import * as Sentry from "@sentry/nextjs"

// Replaces the root layout when it fails, so it renders its own document and
// cannot rely on the app stylesheet.
export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string }
  retry: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100dvh",
          display: "grid",
          placeItems: "center",
          padding: 16,
          background: "#f7f2e8",
          color: "#171717",
          fontFamily: "system-ui, sans-serif",
          textAlign: "center",
        }}
      >
        <main>
          <h1 style={{ margin: "0 0 16px", fontSize: 36, fontWeight: 900 }}>
            Something went wrong
          </h1>
          <p style={{ margin: "0 0 32px", color: "#655d54" }}>
            An unexpected error occurred. Please try again.
          </p>
          <button
            type="button"
            onClick={retry}
            style={{
              minHeight: 48,
              padding: "0 32px",
              border: 0,
              borderRadius: 999,
              background: "#18181b",
              color: "#fff",
              font: "inherit",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </main>
      </body>
    </html>
  )
}
